import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { whatHappenNext, ourTeamReviewed } from './CommonMessages';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import LoadingButton from '../../../lowLevel/LoadingButton';
import themeInfo from '../../../../themes/themes';

const useStyles = makeStyles((theme: any) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  dialogAction: { alignSelf: 'center' },
  button: {
    marginTop: theme.spacing(2),
    minWidth: 175,
  },
}));

export default function SellerQuality({ loading, closeDialog, storeName }) {
  const classes = useStyles();
  const theme = process.env.REACT_APP_THEME;

  const content = (
    <>
      {ourTeamReviewed('seller', storeName)}
      {whatHappenNext(themeInfo[theme].company)}
    </>
  );

  const actions = (
    <LoadingButton
      className={classes.button}
      loading={loading}
      onClick={closeDialog}
    >
      <b>Go to Demand Console</b>
    </LoadingButton>
  );

  return (
    <>
      <DialogContent className={classes.root}>{content}</DialogContent>
      <DialogActions className={classes.dialogAction}>{actions}</DialogActions>
    </>
  );
}
